var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.707 5.69645C20.0975 5.30836 20.0975 4.67915 19.707 4.29106C19.3165 3.90298 18.6833 3.90298 18.2928 4.29106L11.9497 10.5946L5.70707 4.39094C5.31655 4.00285 4.68339 4.00285 4.29286 4.39094C3.90234 4.77903 3.90234 5.40824 4.29286 5.79633L10.5355 12L4.29277 18.2037C3.90225 18.5918 3.90225 19.221 4.29277 19.6091C4.6833 19.9971 5.31646 19.9971 5.70698 19.6091L11.9497 13.4053L18.2929 19.7089C18.6834 20.097 19.3166 20.097 19.7071 19.7089C20.0976 19.3208 20.0976 18.6916 19.7071 18.3035L13.3639 12L19.707 5.69645Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.b5d034d0065910e3092e73f3c5ed15d2.svg";
export { ForwardRef as ReactComponent };